const urlKnowledgeBase = 'https://support.sparxreader.com/';

export const urlTicketDeflector = `${urlKnowledgeBase}docs/ticket-deflector/how-can-we-help-you?p=r0`;

export const articleKeyContacts = `${urlKnowledgeBase}docs/which-key-contacts-do-you-ask-for-and-why`;

export const articleSparxReaderLibrary = `${urlKnowledgeBase}docs/the-sparx-reader-library`;
